import { CALENDAR_ROUTES } from '@/constants';
import { axiosBaseQuery } from '@/services/axios-base-query';
import type { AddCalendarEventPayload, CalendarUserAllTasksResponse } from '@/types';
import { createApi } from '@reduxjs/toolkit/query/react';

export const calendarApi = createApi({
  reducerPath: 'CalendarApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['CalendarTasks'],
  endpoints: (builder) => ({
    getUserAllCalendarTasks: builder.query<
      CalendarUserAllTasksResponse,
      { tenant: string }
    >({
      query: ({ tenant }) => ({
        url: CALENDAR_ROUTES.GET_USER_ALL_TASKS(tenant),
        method: 'GET',
      }),
      providesTags: ['CalendarTasks'],
    }),
    addEventWithInvitations: builder.mutation<
      Record<string, unknown>,
      { tenant: string; data: AddCalendarEventPayload }
    >({
      query: ({ tenant, data }) => ({
        url: CALENDAR_ROUTES.ADD_EVENTS_WITH_INVITATIONS(tenant),
        method: 'POST',
        data,
      }),
      invalidatesTags: ['CalendarTasks'],
    }),
    updateEventWithInvitations: builder.mutation<
      Record<string, unknown>,
      { tenant: string; eventId: number; data: AddCalendarEventPayload }
    >({
      query: ({ tenant, eventId, data }) => ({
        url: CALENDAR_ROUTES.UPDATE_EVENT_WITH_INVITATIONS(tenant, eventId),
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['CalendarTasks'],
    }),
    deleteEventWithInvitations: builder.mutation<
      Record<string, unknown>,
      { tenant: string; eventId: number }
    >({
      query: ({ tenant, eventId }) => ({
        url: CALENDAR_ROUTES.DELETE_EVENT_WITH_INVITATIONS(tenant, eventId),
        method: 'DELETE',
      }),
      invalidatesTags: ['CalendarTasks'],
    }),
  }),
});

export const {
  useGetUserAllCalendarTasksQuery,
  useAddEventWithInvitationsMutation,
  useUpdateEventWithInvitationsMutation,
  useDeleteEventWithInvitationsMutation,
} = calendarApi;
